const YOUR_DOMAIN = window.location.origin;
const YOUR_DOMAIN_LENGTH = YOUR_DOMAIN.length;
const DEFAULT_LANGUAGE = "pt";
const OTHER_LANGUAGES = ["en"];
const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE, ...OTHER_LANGUAGES];
const LANGUAGE_COOKIE_NAME = "language";
const BROWSER_LANGUAGES = navigator.languages;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) 
    return parts.pop().split(';').shift();
}

function calculateLocalizationRedirect(){
  let selectedLang = getCookie(LANGUAGE_COOKIE_NAME)
  const url = window.location.href;
  const path = url.slice(YOUR_DOMAIN_LENGTH);
  let contentPath = path;
  let isDefaultUrl = true;
  let urlLang = DEFAULT_LANGUAGE;
  for (const otherLang of OTHER_LANGUAGES){
    if (path.startsWith(`/${otherLang}`)) {
      contentPath = path.slice(otherLang.length+1);
      urlLang = otherLang;
      isDefaultUrl = false;        
      break;
    }
  }
  if (!selectedLang) {    
    for (const browserLang of BROWSER_LANGUAGES){
      for (const lang of SUPPORTED_LANGUAGES){
        if (browserLang.includes(lang)){
          document.cookie = `${LANGUAGE_COOKIE_NAME}=${lang};domain=.miniversos.pt;path=/`;
          const isDefaultLang = lang === DEFAULT_LANGUAGE;
          if (isDefaultLang) {
            if (isDefaultUrl) {
              console.log(`redirect not needed (already on /)`);
            } else {
              const redirectUrl = url.slice(0, YOUR_DOMAIN_LENGTH) + contentPath;
              console.log(`will redirect to ${redirectUrl}`);
              window.location.href = redirectUrl;
            }
          } else {
            if (url.includes(`${YOUR_DOMAIN}/${lang}`)){
              console.log(`redirect not needed (already on /${lang})`);
            } else {
              const redirectUrl = url.slice(0, YOUR_DOMAIN_LENGTH) + `/${lang}` + contentPath;
              console.log(`will redirect to ${redirectUrl}`)
              window.location.href = redirectUrl;
            }
          }
          return;
        }
      }
    }
  } else if (selectedLang !== urlLang) {
    let redirectUrl;
    if (selectedLang === DEFAULT_LANGUAGE) {
      redirectUrl = url.slice(0, YOUR_DOMAIN_LENGTH) + contentPath;
    } else {
      redirectUrl = url.slice(0, YOUR_DOMAIN_LENGTH) + `/${selectedLang}` + contentPath;
    }
    console.log(`will redirect to ${redirectUrl}`)
    window.location.href = redirectUrl;
  } else {
    console.log(`all is good, no need to redirect...`)
  }
}

calculateLocalizationRedirect();
